import { useEffect    } from 'react';

export const  useClickOutside = (ref, handler)=> {
  useEffect(() => {
    const handleClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        handler();
      }
    };

    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown',   
 handleClick);
    };
  }, [ref, handler]);   

}

 